// Bottom navigation, the web equivalent of the Android `NavigationBar`.
import { useStore } from '../store';
import type { Tab } from '../types';

const TABS: ReadonlyArray<{ id: Tab; icon: string; label: string }> = [
  { id: 'talk', icon: '💬', label: 'Talk' },
  { id: 'practice', icon: '🎤', label: 'Pronounce' },
  { id: 'progress', icon: '📈', label: 'Progress' },
];

export default function TabBar() {
  const s = useStore();
  return (
    <nav className="tabbar" aria-label="Main">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => s.selectTab(tab.id)}
          aria-current={s.tab === tab.id ? 'page' : undefined}
        >
          <span className="icon" aria-hidden="true">
            {tab.icon}
          </span>
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
